"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
require("./index.scss");
const mobx_react_1 = require("mobx-react");
const react_helmet_1 = require("react-helmet");
const contexts_1 = require("@App/contexts");
const navigation_1 = __importDefault(require("@App/navigation"));
const RightsholderContactInformationEdit_1 = __importDefault(require("@Components/RightsholderContact/RightsholderContactInformationEdit"));
const RightsholderContactInformationView_1 = __importDefault(require("@Components/RightsholderContact/RightsholderContactInformationView"));
const ModalPortal_1 = __importDefault(require("@Components/Popups/ModalPortal"));
const Popup_1 = __importDefault(require("@Components/Popups/Popup"));
const ConfirmationPopup_1 = __importDefault(require("@Components/Popups/ConfirmationPopup"));
const NakedButton_1 = require("@Components/Buttons/NakedButton");
const react_router_dom_1 = require("react-router-dom");
const ContentHeader_1 = __importDefault(require("@Components/ContentHeader"));
const RightsholderContactInformationContentHeader_1 = __importDefault(require("@Scenes/RightsholderScene/RightsholderContactInformation/RightsholderContactInformationContentHeader"));
const analytics_utils_1 = require("@App/common/utils/analytics-utils");
const RightsholderContactInformation = (0, mobx_react_1.observer)(() => {
    const params = (0, react_router_dom_1.useParams)();
    const [isEditable, setIsEditable] = (0, react_1.useState)(false);
    const [isPopupOpen, setIsPopupOpen] = (0, react_1.useState)(false);
    const [isNew, setIsNew] = (0, react_1.useState)(false);
    const navigate = (0, react_router_dom_1.useNavigate)();
    const { rightsholderStore, contactStore, popupStore, preloaderStore } = (0, react_1.useContext)(contexts_1.StoresContext);
    const goBack = () => {
        if (isEditable) {
            setIsPopupOpen(true);
        }
        else {
            navigate(-1);
        }
    };
    const loadDataFromUrlValues = () => __awaiter(void 0, void 0, void 0, function* () {
        if (!params.contactId) {
            navigate(navigation_1.default.rightholder.maintenance.memberContacts(params.rightsholderId || rightsholderStore.currentRightsholderId));
            return;
        }
        yield contactStore.loadRightsholderContactById(params.contactId).catch((error) => {
            popupStore.setAlertData(error.message, true);
            navigate(navigation_1.default.rightholder.maintenance.memberContacts(params.rightsholderId || rightsholderStore.currentRightsholderId));
        });
    });
    const setData = () => __awaiter(void 0, void 0, void 0, function* () {
        preloaderStore.openTransparentPreloader(true);
        if (params.contactId === 'new') {
            setIsEditable(true);
            setIsNew(true);
        }
        else {
            if (!contactStore.rightsholderContact) {
                yield loadDataFromUrlValues();
            }
        }
        preloaderStore.openTransparentPreloader(false);
    });
    const setEditable = (obj) => __awaiter(void 0, void 0, void 0, function* () {
        setIsEditable(obj.isEditable);
        setIsNew(obj.isNew);
        yield setData();
    });
    const handleCancelCancel = () => {
        setIsPopupOpen(false);
    };
    const confirmedCancelChanges = () => {
        if (isNew) {
            navigate(-1);
        }
        else {
            setIsEditable(false);
            setIsNew(false);
            setIsPopupOpen(false);
        }
    };
    (0, react_1.useEffect)(() => {
        (0, analytics_utils_1.analyticsSendPage)('rightsholder_contact');
        setData().then();
        return () => contactStore.setRightsholderContact(null);
    }, []);
    if (!contactStore.rightsholderContact && !isNew) {
        return null;
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_helmet_1.Helmet, { title: 'Contact Information' }),
        react_1.default.createElement("div", { className: 'global-container' },
            react_1.default.createElement("div", { className: "rightsholder-contact-information" },
                react_1.default.createElement("div", { className: "head-block" },
                    react_1.default.createElement(ContentHeader_1.default, { title: 'Contact Information', navLeft: react_1.default.createElement(NakedButton_1.NakedButton, { onClick: goBack }, "< Back"), descriptionElement: react_1.default.createElement(RightsholderContactInformationContentHeader_1.default, null) })),
                isEditable ? (react_1.default.createElement(RightsholderContactInformationEdit_1.default, { createRightsholderContact: isNew, goBack: goBack })) : (react_1.default.createElement(RightsholderContactInformationView_1.default, { setIsEditableState: setEditable })))),
        react_1.default.createElement(ModalPortal_1.default, { isOpen: isPopupOpen, onClose: handleCancelCancel },
            react_1.default.createElement(Popup_1.default, { onClose: handleCancelCancel },
                react_1.default.createElement(ConfirmationPopup_1.default, { title: "Are you sure you want to cancel?", onCancel: handleCancelCancel, onConfirm: confirmedCancelChanges, cancelButtonText: "Go Back", confirmButtonText: "Yes, I want to cancel", confirmButtonClassName: "confirm-delete-contact-button" },
                    react_1.default.createElement("p", { className: 'sub-text' }, "Clicking cancel will not save any of the changes you may have made."))))));
});
exports.default = RightsholderContactInformation;
